import { useEffect, useState } from "react";
import API from "../../services/api";
import getImageUrl from "../../utils/imageUrl";

import BusinessLayout from "../layouts/BusinessLayout";
import "./BusinessProfile.css";

function BusinessProfile() {

  const [provider, setProvider] = useState(null);

  useEffect(() => {
    fetchProvider();
  }, []);

  const fetchProvider = async () => {
    try {

      const token = localStorage.getItem("token");

      const res = await API.get("/provider/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setProvider(res.data.provider);

    } catch (error) {
      console.log(error);
    }
  };

  if (!provider) {
    return (
      <BusinessLayout>
        <h2>Loading...</h2>
      </BusinessLayout>
    );
  }

  return (
    <BusinessLayout>

      <div className="business-profile">

        {/* Cover Image */}
        <img
          className="cover-image"
          src={
            provider.coverImage
              ? getImageUrl(provider.coverImage)
              : "/images/default-business.jpg"
          }
          alt="Cover"
          onError={(event) => {
            event.currentTarget.src =
              "/images/default-business.jpg";
          }}
        />

        {/* Profile Image */}
        <img
          className="profile-image"
          src={
            provider.profileImage
              ? getImageUrl(provider.profileImage)
              : "/images/default-logo.png"
          }
          alt="Profile"
          onError={(event) => {
            event.currentTarget.src =
              "/images/default-logo.png";
          }}
        />

        <h1>{provider.businessName}</h1>

        <p>🏠 {provider.providerType}</p>

        <p>📞 {provider.phone}</p>

        <p>📧 {provider.email}</p>

        <p>📍 {provider.address}</p>

        <p>
          {provider.city}, {provider.state}
        </p>

        <p>{provider.description}</p>

        <p>
          🚚 Delivery Radius: {provider.deliveryRadius} KM
        </p>

      </div>

    </BusinessLayout>
  );
}

export default BusinessProfile;